import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import PageHeading from '../PageHeading'
import Div from '../Div'
import Spacing from '../Spacing'
import blogs from '../Pages/blogs.json';
import DOMPurify from 'dompurify';

export default function BlogDetailsPage() {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);
  const sanitizedHTML = DOMPurify.sanitize(blog.text);
  pageTitle('Blog Details');
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  if (!blog) {
    return (
      <Div className="container">
        <Spacing lg='90' md='45'/>
        <h2>Blog Not Found</h2>
        <p>The blog you're looking for does not exist.</p>
        <Link to="/blog">Go back to Blog</Link>
      </Div>
    );
  }
  return (
    <>
    {/* Start Page Heading Section */}
      <PageHeading 
        title={blog.title}
        bgSrc='/images/blog_details_hero_bg.jpeg'
        pageLinkText={blog.id}
      />
      {/* End Page Heading Section */}

      {/* Start Blog Details */}
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-8">

            {/* Start Details Post Content */}
            <Div className="cs-post cs-style2">
              <Div className="cs-post_thumb cs-radius_15">
                <img src={blog.image} alt="Post" className="w-100 cs-radius_15" />
              </Div>
              <Div className="cs-post_info">
                <Div className="cs-post_meta cs-style1 cs-ternary_color cs-semi_bold cs-primary_font">
                  <span className="cs-posted_by">{blog.posted}</span>
                  {blog.categories.map((category) => (
                    <span key={category} className="cs-category-labels">
                      {category}
                    </span>
                  ))}
                </Div>
                <h2 className="cs-post_title">{blog.title}</h2>
                <div className="editor-content" dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
                </Div>
            </Div>
          </Div>
          {/* <Div className="col-xl-3 col-lg-4 offset-xl-1">
            <Spacing lg='0' md='80'/>
            <Sidebar />
          </Div> */}
        </Div>
      </Div>
      {/* Start Blog Details */}
    </>
  )
}
